module.exports = __webpack_public_path__ + "img/id-lqtajwid-1.0a875dc0.webp";